import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconRedo = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M16.617 4.242a.73.73 0 0 0-.21.54.792.792 0 0 0 .234.515l2.625 2.484H8.719c-.922 0-1.79.18-2.602.54a6.899 6.899 0 0 0-2.156 1.452 6.648 6.648 0 0 0-1.43 2.133 6.524 6.524 0 0 0-.539 2.625v4.711c0 .219.07.399.211.54.156.14.336.21.54.21.202 0 .374-.07.515-.21a.693.693 0 0 0 .234-.54v-4.71c0-.72.14-1.4.422-2.04a5.074 5.074 0 0 1 1.102-1.664A5.79 5.79 0 0 1 6.68 9.703a5.017 5.017 0 0 1 2.039-.422h10.547L16.64 11.79a.817.817 0 0 0-.235.54c0 .202.07.374.211.515a.75.75 0 0 0 .516.258.741.741 0 0 0 .539-.235l4.172-3.96a.444.444 0 0 0 .164-.352.47.47 0 0 0-.164-.375l-4.172-3.985a.697.697 0 0 0-.54-.187.668.668 0 0 0-.515.234z" }),
});

export { IconRedo };
